// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MXpy3P73Csg7wIaTyKiO{border-bottom:1px solid var(--border-neutral-default);justify-content:space-between;align-items:center;height:80px;padding:24px 20px;display:flex}.ipKLO4rAhVzRmj2ageQo{align-items:center;gap:8px;width:100%;display:flex}.BA2Jq1coDFA81VJsHLUf{align-items:center;gap:8px;display:flex}.glOMELNHYy4WJLfilgKC{width:100%;padding-left:4px;font-size:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `MXpy3P73Csg7wIaTyKiO`,
	"left": `ipKLO4rAhVzRmj2ageQo`,
	"right": `BA2Jq1coDFA81VJsHLUf`,
	"search": `glOMELNHYy4WJLfilgKC`
};
export default ___CSS_LOADER_EXPORT___;
